const locationOptions = [
  {label: 'Groningen', value: 'Groningen'},
  {label: 'Breukelen', value: 'Breukelen'},
];

export default locationOptions;
